// import React, { useState, useRef } from "react";
// import { toast } from "react-toastify";
// import emailjs from "@emailjs/browser";

// function ContactUs() {
//   const [formData, setFormData] = useState({
//     name: "",
//     number: "",
//     email: "",
//     message: "",
//   });
//   const [errors, setErrors] = useState({});
//   const formRef = useRef();

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//     setErrors((prevErrors) => ({ ...prevErrors, [id]: "" }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const newErrors = {};
//     const requiredFields = ["name", "number", "email", "message"];
//     requiredFields.forEach((field) => {
//       if (!formData[field]?.trim()) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
//       }
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       toast.error("Please fill out all required fields!");
//       return;
//     }

//     emailjs
//       .send(
//         process.env.REACT_APP_EMAILJS_SERVICE_ID,
//         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
//         {
//           name: formData.name,
//           number: formData.number,
//           email: formData.email,
//           message: formData.message,
//         },
//         process.env.REACT_APP_EMAILJS_PUBLIC_KEY
//       )
//       .then(
//         () => {
//           toast.success("Thank you for reaching out! We will get back to you soon.");
//           setFormData({
//             name: "",
//             number: "",
//             email: "",
//             message: "",
//           });
//         },
//         () => {
//           toast.error("Error sending message!");
//         }
//       );
//   };

//   return (
//     <div className="bg-gray-100 flex items-center justify-center font-playfair ">
//       <div className="bg-white shadow-2xl overflow-hidden w-full h-full flex flex-col lg:flex-row">
//         {/* Left Section - Image */}
//         <div className="w-full relative">
//           <img
//             src="images/zebra.webp"
//             alt="Contact Us"
//             className="w-full h-[600px] lg:h-screen object-cover"
//           />
//           <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
//           <div className="absolute bottom-8 left-8 text-white">
//             <h2 className="text-4xl font-bold mb-2">We're here to help!</h2>
//             <p className="text-lg">Feel free to reach out anytime.</p>
//           </div>
//         </div>

//         {/* Right Section - Form */}
//         <div className="w-full flex items-center justify-center p-4 md:p-8 lg:p-12">
//           <div className="w-full max-w-2xl">
//             <h1 className="text-3xl md:text-6xl font-extrabold text-gray-800 mb-4 text-center">Schedule a Call with Us</h1>
//             <p className="text-gray-600 text-center mb-6">
//              Please Fill in the and details we will get back to you at scheduled time.
//             </p>
//             <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
//               <div className="flex justify-between ">
//               <div>
//                 <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">
//                   First Name
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full border md:w-[320px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//                 />
//                 {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//               </div>
//               <div>
//                 <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">
//                   Last Name
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full md:w-[320px] border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//                 />
//                 {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//               </div>
//               </div>
             
//              <div className="flex justify-between">
//              <div>
//                 <label htmlFor="number" className="block text-lg font-medium text-gray-700 mb-2">
//                   Phone Number
//                 </label>
//                 <input
//                   type="tel"
//                   id="number"
//                   value={formData.number}
//                   onChange={handleChange}
//                   className="w-full border md:w-[320px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//                 />
//                 {errors.number && <p className="text-red-500 text-sm mt-1">{errors.number}</p>}
//               </div>
//               <div>
//                 <label htmlFor="email" className="block text-lg font-medium text-gray-700 mb-2">
//                   Email Address
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full border md:w-[320px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//               </div>
//              </div>

// <div className="flex justify-between">
// <div>
//   <label htmlFor="date" className="block text-lg font-medium text-gray-700 mb-2">
//     Select Date
//   </label>
//   <input
//     type="date"
//     id="email"
//     value={formData.email}
//     onChange={handleChange}
//     className="w-full border md:w-[200px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//   />
//   {errors.email && <p className="text-red-500 text-sm mt-1">{errors.date}</p>}
//               </div>

//               <div>
//   <label htmlFor="time" className="block text-lg font-medium text-gray-700 mb-2">
//     Select Time
//   </label>
//   <input
//     type="time"
//     id="time"
//     value={formData.email}
//     onChange={handleChange}
//     className="w-full border md:w-[200px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//   />
//   {errors.email && <p className="text-red-500 text-sm mt-1">{errors.date}</p>}
//               </div>


//               <div className="w-full border md:w-[200px] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400">
                
//                 <select >
//                 <option>Select Individuals</option>
//                   <option>Ritika kapoor</option>
//                   <option>Gaurav kapoor</option>

//                 </select>
//               </div>
              
// </div>
             
             
//               <div>
//                 <label htmlFor="message" className="block text-lg font-medium text-gray-700 mb-2">
//                   Message for Us
//                 </label>
//                 <textarea
//                   id="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//                   rows="5"
//                 />
//                 {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
//               </div>
//               <button
//                 type="submit"
//                 className="w-full bg-gradient-to-r from-blue-500 to-teal-500 text-white text-lg font-semibold py-3 rounded-lg hover:opacity-90 transition-opacity duration-200"
//               >
//                 Send Message
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactUs;
import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    number: "",
    email: "",
    dateTime: "",
    message: "",
    individual: "",
  });

  const [errors, setErrors] = useState({});
  const formRef = useRef();

  // Prevent past dates & times
  const getMinDateTime = () => {
    const now = new Date();
    return now.toISOString().slice(0, 16);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [id]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    const requiredFields = ["name", "lastName", "number", "email", "dateTime", "message", "individual"];
    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill out all required fields!");
      return;
    }

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          name: formData.name,
          lastName: formData.lastName,
          number: formData.number,
          email: formData.email,
          dateTime: formData.dateTime,
          message: formData.message,
          individual: formData.individual,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success("Thank you for reaching out! We will get back to you soon.");
          setFormData({
            name: "",
            lastName: "",
            number: "",
            email: "",
            dateTime: "",
            message: "",
            individual: "",
          });
        },
        () => {
          toast.error("Error sending message!");
        }
      );
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center font-playfair ">
      <div className="bg-white shadow-2xl w-full  flex flex-col lg:flex-row ">
        {/* Left Section - Image */}
        <div className="w-full lg:w-1/2 relative">
          <img src="images/zebra.webp" alt="Contact Us" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
          <div className="absolute top-1/2 md:bottom-40 left-8 text-white">
            <h2 className="text-4xl  md:text-6xl font-bold mb-2">We're here to help!</h2>
            <p className="text-2xl">Feel free to reach out anytime.</p>
          </div>
        </div>

        {/* Right Section - Form */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-6  py-12 xl:px-32">
          <div className="w-full">
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-4 text-center">Schedule a Call</h1>
            <h2 className="text-gray-600 text-center mb-6">
              Fill in your details, and we'll get back to you at the scheduled time.
            </h2>

            <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">First Name</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-lg font-medium text-gray-700 mb-2">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  />
                  {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                </div>
              </div>

              {/* Contact Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="number" className="block text-lg font-medium text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    id="number"
                    value={formData.number}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  />
                  {errors.number && <p className="text-red-500 text-sm mt-1">{errors.number}</p>}
                </div>
                <div>
                  <label htmlFor="email" className="block text-lg font-medium text-gray-700 mb-2">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>
              </div>

              {/* Date & Time + Dropdown */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="dateTime" className="block text-lg font-medium text-gray-700 mb-2">Schedule Date & Time</label>
                  <input
                    type="datetime-local"
                    id="dateTime"
                    value={formData.dateTime}
                    onChange={handleChange}
                    min={getMinDateTime()}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  />
                  {errors.dateTime && <p className="text-red-500 text-sm mt-1">{errors.dateTime}</p>}
                </div>
                <div>
                  <label htmlFor="individual" className="block text-lg font-medium text-gray-700 mb-2">Select Individual</label>
                  <select
                    id="individual"
                    value={formData.individual}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                  >
                    <option value="">Select an Individual</option>
                    <option value="Ritika Kapoor">Ritika Kapoor</option>
                    <option value="Gaurav Kapoor">Gaurav Kapoor</option>
                  </select>
                  {errors.individual && <p className="text-red-500 text-sm mt-1">{errors.individual}</p>}
                </div>
              </div>

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-lg font-medium text-gray-700 mb-2">Message</label>
                <textarea
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <button className="w-full bg-blue-500 text-white text-lg font-semibold py-3 rounded-lg hover:bg-blue-600 transition">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
